var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location_svg__Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".location_svg__cls-1{fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "location_svg__cls-1",
    d: "M15 5c-1.85 0-3.63.75-4.94 2.1A7.261 7.261 0 0 0 8 12.19c0 .97.42 2.27 1.15 3.75.72 1.46 1.69 2.99 2.67 4.39.98 1.4 1.97 2.66 2.71 3.56.17.21.33.4.48.58.14-.17.3-.36.48-.58.74-.91 1.72-2.16 2.71-3.56.98-1.4 1.95-2.93 2.67-4.39.73-1.48 1.15-2.78 1.15-3.75 0-1.91-.74-3.74-2.06-5.09A6.92 6.92 0 0 0 15.02 5Zm0 21-.75.66-.02-.03-.07-.08c-.06-.07-.15-.17-.26-.3a61.349 61.349 0 0 1-3.71-4.78c-1.02-1.45-2.05-3.07-2.83-4.66-.77-1.56-1.35-3.19-1.35-4.63 0-2.43.94-4.76 2.63-6.48C10.33 3.98 12.62 3 15.01 3s4.69.97 6.37 2.7a9.255 9.255 0 0 1 2.63 6.48c0 1.44-.58 3.08-1.35 4.63-.78 1.58-1.81 3.21-2.83 4.66a65.904 65.904 0 0 1-2.79 3.68c-.38.47-.7.84-.92 1.1-.11.13-.2.23-.26.3l-.07.08-.02.02-.75-.66Zm0 0 .75.66c-.19.21-.46.34-.75.34s-.56-.12-.75-.34L15 26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "location_svg__cls-1",
    d: "M15 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm-4 2c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4Z"
  })));
};

export default SvgLocation;